import { type Dayjs as DayjsType } from "dayjs"

import { type ATTENDANCE_STATUSES } from "#constants/globalConstants"

import { ReactChild, type Uuid } from "./globalTypes"

export type Enum<T> = keyof T
export type EnumValues<T> = T[keyof T]

export type TypesafeAny =
  | string
  | number
  | boolean
  | null
  | undefined
  | object
  | TypesafeAny[]
export type GenericObject = Record<string, TypesafeAny> & { id?: string }
export type DatabaseObject = GenericObject & {
  id: string
  createdAt: IsoDate
  createdBy: Uuid
  lastUpdatedAt: IsoDate
  lastUpdatedBy: Uuid
}
export type DataWithId = GenericObject & { id: Uuid }
export type FormData = GenericObject & { id?: Uuid | undefined }

export function invariant(
  condition: boolean,
  message: string
): asserts condition {
  if (!condition) {
    throw new Error(`Invariant failed: ${message}`)
  }
}

export type TableData = {
  id: Uuid
} & Record<string, string | ReactChild>

export interface EventType extends Event {
  resourceId: string
  color: string
}

export interface Address {
  street1: string
  street2: string
  city: string
  state: string
  zipCode: string
}

export type Semester = string
export type IsoDate = string
export type Dayjs = DayjsType

export type AttendanceStatus = EnumValues<typeof ATTENDANCE_STATUSES>

export interface AttendanceClassSession {
  // TODO: Add more values
  // eventStart: number
  // formattedDate: string
  status: AttendanceStatus
  sessionId: Uuid // Session ids are `classId-sessionIndex`
}

export type AttendanceClassSessions = AttendanceClassSession[]
// Attendance is saved by classId
export type Attendance = Record<Uuid, AttendanceClassSessions>
